<template>
    <v-icon v-if="contentType == 1">{{ mdiFormatQuoteClose }}</v-icon>
    <v-icon v-else-if="contentType == 2">{{ mdiImage }}</v-icon>
    <v-icon v-else-if="contentType == 3">{{ mdiVideo }}</v-icon>
    <v-icon v-else-if="contentType == 4">{{ mdiCalendar }}</v-icon>
</template>

<script>
import { mdiImage, mdiFormatQuoteClose, mdiVideo, mdiCalendar } from '@mdi/js';

export default {
    props: [
        'contentType'
    ],
    setup(props) {
        return {
            mdiImage,
            mdiFormatQuoteClose,
            mdiVideo,
            mdiCalendar
        }
    }
}
</script>
